const collection = () => ({
    loading: false,
    infiniteLoading: false,
    windowWidth: window.innerWidth,
    query: '',
    hasActiveFilters: false,
    urlParams: '',
    mobileFiltersShow: false,
    body: null,
    dropdowns: null,
    openDetailElement: null,
    filterForm: null,
    count: null,
    paginateItems: null,
    filterFormMobile: null,
    sort: null,
    collectionData: null,
    html_dom: null,
    collectionCurrentPath: null,
    columns: 4,
    nextPageUrl: null,
    scrollObserver: null,
    /**
     * Build query string from form, excluding empty values and price-radio-only params
     * so we don't add ?filter.v.price.gte=&filter.v.price.lte= or lsa-dialog-price-* when no price is selected.
     */
    formToQueryString(form) {
      if (!form) return ''
      const params = new URLSearchParams()
      const formData = new FormData(form)
      for (const [key, value] of formData) {
        const val = (value || '').toString().trim()
        if (val === '') continue
        if (key.startsWith('lsa-dialog-price-') || key.startsWith('lsa-mobile-price-')) continue
        params.append(key, value)
      }
      return params.toString()
    },
    init(){
        this.body = document.querySelector('body')
        this.dropdowns = document.querySelectorAll('.filter-dropdown')
        this.collectionData = JSON.parse(document.querySelector('[data-collection-json]').textContent);
        const defaultCols = parseInt(this.collectionData.default_columns, 10)
        this.columns = (defaultCols >= 2 && defaultCols <= 4) ? defaultCols : 4
        this.collectionCurrentPath =  this.collectionData.current_path;
        this.qParam = this.collectionData.q_param || '';
        this.count =  this.collectionData.paginate_count;
        this.paginateItems =  this.collectionData.paginate_items
        this.filterForm = document.querySelector('[data-filter-form]')
        this.filterFormMobile = document.querySelector('[data-mobile-filter]')
        this.urlParams = new URL(window.location.href)
        this.nextPageUrl = this.collectionData.next_url || null
        this.setupInfiniteScroll()
    },
    setupInfiniteScroll() {
      if (this.scrollObserver) {
        this.scrollObserver.disconnect()
      }
      const sentinel = document.querySelector('#infinite-scroll-sentinel')
      if (!sentinel) return
      this.scrollObserver = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && this.nextPageUrl && !this.infiniteLoading) {
          this.infiniteLoadMore()
        }
      }, { rootMargin: '800px' })
      this.scrollObserver.observe(sentinel)
    },
    async infiniteLoadMore() {
      if (!this.nextPageUrl || this.infiniteLoading) return
      this.infiniteLoading = true
      const url = this.nextPageUrl
      this.nextPageUrl = null
      try {
        const response = await fetch(url)
        const data = await response.text()
        const html_div = document.createElement('div')
        html_div.innerHTML = data

        const newGrid = html_div.querySelector('#product_grid')
        if (newGrid) {
          document.querySelector('#product_grid').insertAdjacentHTML('beforeend', newGrid.innerHTML)
        }

        const newCollectionData = html_div.querySelector('[data-collection-json]')
        if (newCollectionData) {
          const parsed = JSON.parse(newCollectionData.textContent)
          this.nextPageUrl = parsed.next_url || null
        }
      } catch (error) {
        console.error('Error loading more products:', error)
        this.nextPageUrl = url
      } finally {
        this.infiniteLoading = false
      }
    },
     sortCollection(){
        const PageMediaQuery = window.matchMedia('(max-width: 990px)')
        const form = PageMediaQuery.matches && this.filterFormMobile != null ? this.filterFormMobile : this.filterForm
        const queryString = this.formToQueryString(form)

        const sortSelector = PageMediaQuery.matches
          ? document.querySelector('#mobile-sort_by[data-sort-by]')
          : document.querySelector('#desktop-sort_by[data-sort-by]')
        const fallbackSortSelect = !sortSelector ? document.querySelector('[data-sort-by]') : null
        let sortValue = 'sort_by'
        if (sortSelector && sortSelector.value) {
          sortValue = sortSelector.value
        } else if (fallbackSortSelect && fallbackSortSelect.value) {
          sortValue = fallbackSortSelect.value
        }
        this.sort = sortValue

        const q = [this.qParam, queryString, (this.sort !== 'manual' && this.sort !== 'sort_by') ? 'sort_by=' + this.sort : ''].filter(Boolean).join('&')
        fetch(this.collectionCurrentPath + (q ? '?' + q : ''))
          .then(response => response.text())
          .then(data => {

            let html_div = document.createElement('div');
            html_div.innerHTML = data;

            let html_dom = html_div.querySelector('#ProductGridContainer').innerHTML;
            document.querySelector('#ProductGridContainer').innerHTML = html_dom;

            const newCollectionData = html_div.querySelector('[data-collection-json]')
            if (newCollectionData) {
              const parsed = JSON.parse(newCollectionData.textContent)
              this.nextPageUrl = parsed.next_url || null
            }

            const urlQ = [this.qParam, queryString, (this.sort !== 'manual' && this.sort !== 'sort_by') ? 'sort_by=' + this.sort : ''].filter(Boolean).join('&')
            history.replaceState(null, null, this.collectionCurrentPath + (urlQ ? '?' + urlQ : ''))
          })
          .catch(error => console.error('Error:', error))
          .finally(() => this.loading = false);
      },
      calculateProgressBarWidth(count, paginateItems){
        return (count * 100) / parseInt(paginateItems)  + '%'
      },
      updateFilter(event){
        this.loading = true
        const PageMediaQuery = window.matchMedia('(max-width: 990px)')

        const sortSelector = PageMediaQuery.matches
          ? document.querySelector('#mobile-sort_by[data-sort-by]')
          : document.querySelector('#desktop-sort_by[data-sort-by]')
        const fallbackSortSelect = !sortSelector ? document.querySelector('[data-sort-by]') : null
        let sortValue = 'sort_by'
        if (sortSelector && sortSelector.value) {
          sortValue = sortSelector.value
        } else if (fallbackSortSelect && fallbackSortSelect.value) {
          sortValue = fallbackSortSelect.value
        }
        this.sort = sortValue

        const form = PageMediaQuery.matches && this.filterFormMobile != null ? this.filterFormMobile : this.filterForm
        const queryString = this.formToQueryString(form)
        this.query = queryString
        this.hasActiveFilters = !!queryString

          const q = [this.qParam, queryString, (this.sort !== 'manual' && this.sort !== 'sort_by') ? 'sort_by=' + this.sort : ''].filter(Boolean).join('&')
          fetch(this.collectionCurrentPath + (q ? '?' + q : ''))
          .then(response => response.text())
          .then(data => {

            let html_div = document.createElement('div');
            html_div.innerHTML = data;

            let html_dom = html_div.querySelector('#ProductGridContainer').innerHTML;
            document.querySelector('#ProductGridContainer').innerHTML = html_dom;

            let activeFiltersEl = html_div.querySelector('[data-active-filters-wrap]');
            let activeFiltersCurrent = document.querySelector('[data-active-filters-wrap]');
            if (activeFiltersCurrent) {
              activeFiltersCurrent.innerHTML = activeFiltersEl ? activeFiltersEl.innerHTML : '';
            }

            let inlineFiltersNew = html_div.querySelector('[data-inline-active-filters-wrap]');
            let inlineFiltersCurrentAll = document.querySelectorAll('[data-inline-active-filters-wrap]');
            inlineFiltersCurrentAll.forEach((element) => {
              element.innerHTML = inlineFiltersNew ? inlineFiltersNew.innerHTML : '';
            });

            let dataProductDesktopNew = html_div.querySelectorAll('[data-product-desktop]');
            let dataProductDesktopCurrent =  document.querySelectorAll('[data-product-desktop]');
            dataProductDesktopCurrent.forEach((element, index) => {
              if (dataProductDesktopNew[index]) element.innerHTML = dataProductDesktopNew[index].innerHTML;
            });

            let dataProductMobileNew = html_div.querySelectorAll('[data-product-mobile]');
            let dataProductMobileCurrent =  document.querySelectorAll('[data-product-mobile]');
            dataProductMobileCurrent.forEach((element, index) => {
              if (dataProductMobileNew[index]) element.innerHTML = dataProductMobileNew[index].innerHTML;
            });

            let filterCountNew = html_div.querySelectorAll('.filter-count');
            let filterCountCUrrent =  document.querySelectorAll('.filter-count');
            filterCountCUrrent.forEach((element, index) => {
              if (filterCountNew[index]) element.innerHTML = filterCountNew[index].innerHTML;
            });

            let filterButtonLabelNew = html_div.querySelector('[data-filter-button-label]');
            document.querySelectorAll('[data-filter-button-label]').forEach((el) => {
              if (filterButtonLabelNew) el.innerHTML = filterButtonLabelNew.innerHTML;
            });

            const newCollectionData = html_div.querySelector('[data-collection-json]')
            if (newCollectionData) {
              const parsed = JSON.parse(newCollectionData.textContent)
              this.nextPageUrl = parsed.next_url || null
            }

            // Do not replace filter form or mobile drawer – selection stays visible immediately

            const urlQ = [this.qParam, queryString, (this.sort !== 'manual' && this.sort !== 'sort_by') ? 'sort_by=' + this.sort : ''].filter(Boolean).join('&')
            history.pushState(null, null, this.collectionCurrentPath + (urlQ ? '?' + urlQ : ''))

          })
          .catch(error => console.error('Error:', error))
          .finally(() => this.loading = false);
      },
      clearFilter(){
         this.loading = true;
         let url = this.collectionCurrentPath + (this.qParam ? '?' + this.qParam : '');
        this.pushFilter(url);
      },
      pushFilter(newUrl){
        this.loading = true;

        fetch(newUrl)
          .then(response => response.text())
          .then(data => {
            let html_div = document.createElement('div');
            html_div.innerHTML = data;

            let productGridNew = html_div.querySelector('#ProductGridContainer');
            let productGridCurrent = document.querySelector('#ProductGridContainer');
            if (productGridCurrent && productGridNew) {
              productGridCurrent.innerHTML = productGridNew.innerHTML;
            }

            let filterFormNew = html_div.querySelector('[data-filter-form]');
            let filterFormCurrent = document.querySelector('[data-filter-form]');
            if (filterFormCurrent && filterFormNew) {
              filterFormCurrent.innerHTML = filterFormNew.innerHTML;
            }

            let mobileFilterNew = html_div.querySelector('[data-mobile-filter]');
            let mobileFilterCurrent = document.querySelector('[data-mobile-filter]');
            if (mobileFilterCurrent && mobileFilterNew) {
              mobileFilterCurrent.innerHTML = mobileFilterNew.innerHTML;
            }

            let inlineFiltersNew = html_div.querySelector('[data-inline-active-filters-wrap]');
            let inlineFiltersCurrentAll = document.querySelectorAll('[data-inline-active-filters-wrap]');
            inlineFiltersCurrentAll.forEach((element) => {
              element.innerHTML = inlineFiltersNew ? inlineFiltersNew.innerHTML : '';
            });

            let dataProductDesktopNew = html_div.querySelectorAll('[data-product-desktop]');
            let dataProductDesktopCurrent = document.querySelectorAll('[data-product-desktop]');
            dataProductDesktopCurrent.forEach((element, index) => {
              if (dataProductDesktopNew[index]) element.innerHTML = dataProductDesktopNew[index].innerHTML;
            });

            let dataProductMobileNew = html_div.querySelectorAll('[data-product-mobile]');
            let dataProductMobileCurrent = document.querySelectorAll('[data-product-mobile]');
            dataProductMobileCurrent.forEach((element, index) => {
              if (dataProductMobileNew[index]) element.innerHTML = dataProductMobileNew[index].innerHTML;
            });

            let filterCountNew = html_div.querySelectorAll('.filter-count');
            let filterCountCurrent = document.querySelectorAll('.filter-count');
            filterCountCurrent.forEach((element, index) => {
              if (filterCountNew[index]) element.innerHTML = filterCountNew[index].innerHTML;
            });

            let filterBtnLabelNew = html_div.querySelector('[data-filter-button-label]');
            document.querySelectorAll('[data-filter-button-label]').forEach((el) => {
              if (filterBtnLabelNew) el.innerHTML = filterBtnLabelNew.innerHTML;
            });

            const newCollectionData = html_div.querySelector('[data-collection-json]')
            if (newCollectionData) {
              const parsed = JSON.parse(newCollectionData.textContent)
              this.nextPageUrl = parsed.next_url || null
            }

            history.pushState(null, null, newUrl);

            const newParams = new URL(newUrl, window.location.origin).searchParams;
            this.hasActiveFilters = [...newParams.keys()].some(k => k.startsWith('filter.'));
          })
          .catch(error => console.error('Error:', error))
          .finally(() => {
            this.query = this.formToQueryString(this.filterForm)
            this.loading = false
          });
      },
      openMobileFilters(){
          this.mobileFiltersShow = true
          this.body.style.overflow = 'hidden'
      },
      closeMobileFilters(){
          this.mobileFiltersShow = false
          this.body.style.overflow = 'visible'
      }
  })

  export default collection

  document.addEventListener("alpine:init", () => {
    Alpine.data("collection", collection)
  })
